import { render, staticRenderFns } from "./NewTask.vue?vue&type=template&id=315956b4&scoped=true&"
import script from "./NewTask.vue?vue&type=script&lang=js&"
export * from "./NewTask.vue?vue&type=script&lang=js&"
import style0 from "./NewTask.vue?vue&type=style&index=0&id=315956b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315956b4",
  null
  
)

export default component.exports